<template>
    <div>
        <homen></homen>
        <div class="pagerc">
            <div class="headerimg">
                <img class="pcshow" src="../assets/images/info.jpg" alt="">
                <img class="mshow" src="../assets/images/minfo.png" alt="">
                <div class="title">
                    <div class="titlep">
                        <h3>INFORMATION</h3>
                        <h4>大会信息</h4>
                    </div>
                </div>
            </div>
            <div class="inchild clear">
                <div class="wrapleft">
                    <h2>{{info.info1}}</h2>
                    <div class="wrapbox">
                        <div class="infop">
                            <p>{{info.info2}}</p>
                            <p>{{info.info3}}</p>
                            <p>{{info.info4}}</p>
                        </div>
                        <div class="wpeople">
                            <h5>Who Should Attend</h5>
                            <ul>
                                <li>The scale of the forum is around 400-600 participants from over the world. Target audience include: Corporate executives, corporate HR executives and senior HR leaders, talent management managers and experts, corporate university directors, consultants and professionals in talent management, and so on.</li>
                            </ul>
                            <h6>Time：<span>2019.11.13-11.15</span></h6>
                            <h6>Place：<span>SHANGHAI MARRIOTT HOTEL CITY CENTRE</span></h6>
                        </div>
                        <div class="cblx">
                            <div class="inlinecontact">
                                <h5>Sponsorship contacts：</h5>
                                <ul>
                                    <li><i class="el-icon-coordinate"></i> Mag Mao</li>
                                    <li><i class="el-icon-phone-outline"></i> +86-021-6840 5597</li>
                                    <li><i class="el-icon-message"></i> mag@hrflag.com</li>
                                </ul>
                            </div>
                            <div class="inlinecontact">
                                <h5>Registration Contacts：</h5>
                                 <ul>
                                    <li><i class="el-icon-coordinate"></i> Luffy Liu</li>
                                    <li><i class="el-icon-phone-outline"></i> +86-021-6840-3875</li>
                                    <li><i class="el-icon-message"></i> luffy@hrflag.com</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <wrapright></wrapright>
            </div>
        </div>
        <foot></foot>
    </div>
</template>

<script>
import homen from '@/components/commn/homen'
import foot from '@/components/commn/foot'
import wrapright from '@/components/commn/wrapright'
 export default {
      components:{
        homen,
        foot,
        wrapright
      },
       metaInfo: {
            title: 'International Congress on Assessment Center Methods -  to bring together early adopters and provide a forum for the exchange of knowledge and best practices',
            meta: [
            {
                name: 'keywords',
                content: 'Assessment Center Methods; Assessment Center; International Congress on Assessment Center Methods'
            },
            {
                name: 'description',
                content: 'The International Congress was founded in 1973 by William C. Byham, Ph.D., Chairman of DDI, a global organization specializing in the assessment center method, to bring together early adopters and provide a forum for the exchange of knowledge and best practices.'
            }
            ]
        },
    data () {
        return {
            info: {
                info1: 'History of the International Congress',
                info2: 'The International Congress was founded in 1973 by William C. Byham, Ph.D., Chairman of DDI, a global organization specializing in the assessment center method, to bring together early adopters and provide a forum for the exchange of knowledge and best practices. It has attracted the world’s leading experts, scholars, and practitioners of the assessment center method to present research, new innovations and related technologies, and case studies. From the first International Congress, which set standards and professional guidelines, and identified ethical considerations for the use of the assessment center method, the event’s mission has remained unchanged: to promote and advance the assessment center method as a fair, unbiased approach for hiring and promoting people in public and private organizations, and establish the validity (accuracy) and reliability of assessment centers.',
            }
        }
    }
}
</script>

<style scoped>
    @import url('../assets/css/inpublic.css');
    body {
        color: #333333;
        font-family: '微软雅黑';
    }
    .wpeople ul li {
        color: #333333;
        font-size: 14px;
        line-height: 2;
    }
</style>



// WEBPACK FOOTER //
// src/components/info_en.vue